export const LEFT_COMMUNITY = "LEAVE_COMMUNITY";
export const SET_ALL_MEMBERS = "SET_ALL_MEMBERS";
export const SET_COMMUNITY_MEMBERS = "SET_COMMUNITY_MEMBERS";
export const SET_MEMBERS = "SET_MEMBERS";
export const SET_ADMINS = "SET_ADMINS";
export const REMOVE_ADMIN = "REMOVE_ADMIN";
export const SET_COMMUNITY_SEARCH_TERM = "SET_COMMUNITY_SEARCH_TERM";
export const CLEAR_COMMUNITY_SEARCH_TERM = "CLEAR_SEARCH_TERM";
